export const locale = {
    lang: 'bn',
    data: {
        'NAV': {
            'APPLICATIONS'      : 'অ্যাপ্লিকেশান',
            'DASHBOARDS'        : 'ড্যাশবোর্ড',
            'SUPERADMIN'        : 'অ্যাডমিনিশট্রেশন',
            'ORGANIZATION'      : 'প্রতিষ্ঠান',
            'MARKET'            : 'মার্কেট',
            'MARKET_LEVEL'      : 'মার্কেট লেভেল',
            'USER_ROLE'         : 'পদবি',
            'DISTRIBUTOR'       : 'পরিবেশক',
            'CUSTOMER'          : 'খুচরা বিক্রেতা',
            'PRODUCT'           : 'পণ্য',
            'CAMPAIGN'          : 'প্রচারণা',
            'ORDER'             : 'অর্ডার',
            'INVOICE'           : 'ইনভয়েস',
            'DELIVERY_CHALLAN'  : 'ডেলিভারি চালান',
            'MARKET_HIERARCHY'  : 'মার্কেট বিন্যাশ',
            'USER'              : 'ইউজার',
            'TOUR_PLAN'         : 'সফর পরিকল্পনা',
            'BANK_ACCOUNT'      : 'ব্যাংক অ্যাকাউন্ট',
            'PAYMENT'           : 'পেমেন্ট',
            'ATTENDANCE'        : 'উপস্থিতি',
            'EXPENSE'           : 'খরচ',
            'DAILY_TA_DA'       : 'ভাতা',
            'HOLIDAY'           : 'ছুটি',
            'LOCATION'          : 'ট্র্যাকিং',
            'RETURN'            : 'রিটার্ন',
            'REPORT'            : 'রিপোর্ট',
            'TARGET_ACHIEVEMENT': 'টার্গেট',
            'VISIT'             : 'পরিদর্শন'
        }
    }
};
